import React, { Component } from "react";
import Server from "./Server.js";
import Swiper from "react-id-swiper";
import "swiper/swiper.min.css";

import { connect } from "react-redux";
const sliderParam = {
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
};
class Pages extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();
    this.getPages = this.getPages.bind(this);
    this.myRef = React.createRef(); // Create a ref object
    this.state = {
      id: window.location.href.split("id=")[1],
      loading: 1,
      charts: [],
      videos: [],
      texts: [],
      pics: [],
      sliders: [],
      absoluteUrl: this.Server.getAbsoluteUrl(),
      url: this.Server.getUrl(),
    };
    this.getSettings();
  }
  componentDidMount() {
    document.getElementsByTagName("body")[0].scrollTo(0, 0);
  }
  getPages = () => {
    let that = this;
    if (!this.state.id) return;
    let param = {
      page: this.state.id,
    };

    let SCallBack = (response) => {
      let res = response.data.result[0];
      let sliders = [];
      for (let i = 1; i <= res.slider_number; i++) {
        const sliderTemp = [];
        for (let item in res) {
          if (item.indexOf(`slider_content_${i}`) > -1) {
            sliderTemp.push(res[item]);
          }
        }
        sliders.push(sliderTemp);
      }
      const pics = [];
      for (let item in res) {
        if (item.indexOf(`pic_content_`) > -1) {
          pics.push(res[item]);
        }
      }
      const texts = [];
      for (let item in res) {
        if (item.indexOf(`text_content_`) > -1) {
          texts.push(res[item]);
        }
      }
      const videos = [];
      for (let item in res) {
        if (item.indexOf(`video_content_`) > -1) {
          videos.push(res[item]);
        }
      }
      const charts = [];
      for (let item in res) {
        if (item.indexOf(`chart_content_`) > -1) {
          charts.push(res[item]);
        }
      }
      that.setState({
        charts: charts,
        videos: videos,
        texts: texts,
        pics: pics,
        sliders: sliders,
        loading: 0,
      });
      that.myRef.current.scrollTo(0, 0);
    };
    let ECallBack = (error) => {};
    that.Server.send("AdminApi/getPageLayout", param, SCallBack, ECallBack);
  };

  getSettings() {
    let that = this;
    that.Server.send(
      "AdminApi/getSettings",
      {},
      function (response) {
        if (response.data.result) {
          that.setState({
            ProductBase: response.data.result[0]
              ? response.data.result[0].ProductBase
              : false,
            SaleFromMultiShops: response.data.result[0]
              ? response.data.result[0].SaleFromMultiShops
              : false,
            System: response.data.result[0]
              ? response.data.result[0].System
              : "shop",
          });
        }
        that.getPages();
      },
      function (error) {}
    );
  }
  render() {
    return (
      <div ref={this.myRef} style={{ background: "#fff" }}>
        {!this.state.loading ? (
          <div style={{ direction: "rtl", paddingBottom: 50 }}>
            <div className="container pt-3">
              <div className="rowx">
                {this.state.texts.map((item) => {
                  if (item) {
                    return (
                      <div className="col-lg-12  mb-2">
                        <div
                          dangerouslySetInnerHTML={{ __html: item }}
                          className="iranyekanweblight "
                          style={{ textAlign: "right", overflow: "hidden" }}
                        />
                      </div>
                    );
                  }
                })}
                {this.state.pics.map((item) => {
                  if (item) {
                    return (
                      <div className="col-lg-12  mb-2">
                        <img src={item} style={{ width: "100%" }} />
                      </div>
                    );
                  }
                })}
                {this.state.sliders.map((item) => {
                  return (
                    <div className="col-lg-12 mb-2">
                      <Swiper {...sliderParam}>
                        {item.map((pic) => {
                          return <img src={pic} />;
                        })}
                      </Swiper>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        ) : (
          <div style={{ zIndex: 10000 }}>
            <p style={{ textAlign: "center" }}>
              <img src={this.state.loading_pic} />
            </p>
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(Pages);
